var _excluded = ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react'; //

import { linkColumnStructure, flattenColumns, assignColumnAccessor, unpreparedAccessWarning, makeHeaderGroups, decorateColumn } from '../utils';
import { useGetLatest, reduceHooks, actions, loopHooks, makePropGetter, makeRenderer } from '../publicUtils';
import makeDefaultPluginHooks from '../makeDefaultPluginHooks';
import { useColumnVisibility } from './useColumnVisibility';
var defaultInitialState = {};
var defaultColumnInstance = {};

var defaultReducer = function defaultReducer(state, action, prevState) {
  return state;
};

var defaultGetSubRows = function defaultGetSubRows(row, index) {
  return row.subRows || [];
};

var defaultGetRowId = function defaultGetRowId(row, index, parent) {
  return "".concat(parent ? [parent.id, index].join('.') : index);
};

var defaultUseControlledState = function defaultUseControlledState(d) {
  return d;
};

function applyDefaults(props) {
  var _props$initialState = props.initialState,
      initialState = _props$initialState === void 0 ? defaultInitialState : _props$initialState,
      _props$defaultColumn = props.defaultColumn,
      defaultColumn = _props$defaultColumn === void 0 ? defaultColumnInstance : _props$defaultColumn,
      _props$getSubRows = props.getSubRows,
      getSubRows = _props$getSubRows === void 0 ? defaultGetSubRows : _props$getSubRows,
      _props$getRowId = props.getRowId,
      getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId,
      _props$stateReducer = props.stateReducer,
      stateReducer = _props$stateReducer === void 0 ? defaultReducer : _props$stateReducer,
      _props$useControlledS = props.useControlledState,
      useControlledState = _props$useControlledS === void 0 ? defaultUseControlledState : _props$useControlledS,
      rest = _objectWithoutProperties(props, _excluded);

  return _objectSpread(_objectSpread({}, rest), {}, {
    initialState: initialState,
    defaultColumn: defaultColumn,
    getSubRows: getSubRows,
    getRowId: getRowId,
    stateReducer: stateReducer,
    useControlledState: useControlledState
  });
}

export var useTable = function useTable(props) {
  for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    plugins[_key - 1] = arguments[_key];
  }

  // Apply default props
  props = applyDefaults(props); // Add core plugins

  plugins = [useColumnVisibility].concat(_toConsumableArray(plugins)); // Create the table instance

  var instanceRef = React.useRef({}); // Create a getter for the instance (helps avoid a lot of potential memory leaks)

  var getInstance = useGetLatest(instanceRef.current); // Assign the props, plugins and hooks to the instance

  Object.assign(getInstance(), _objectSpread(_objectSpread({}, props), {}, {
    plugins: plugins,
    hooks: makeDefaultPluginHooks()
  })); // Allow plugins to register hooks as early as possible

  plugins.filter(Boolean).forEach(function (plugin) {
    plugin(getInstance().hooks);
  }); // Consume all hooks and make a getter for them

  var getHooks = useGetLatest(getInstance().hooks);
  getInstance().getHooks = getHooks;
  delete getInstance().hooks; // Allow useOptions hooks to modify the options coming into the table

  Object.assign(getInstance(), reduceHooks(getHooks().useOptions, applyDefaults(props)));

  var _getInstance = getInstance(),
      data = _getInstance.data,
      userColumns = _getInstance.columns,
      initialState = _getInstance.initialState,
      defaultColumn = _getInstance.defaultColumn,
      getSubRows = _getInstance.getSubRows,
      getRowId = _getInstance.getRowId,
      stateReducer = _getInstance.stateReducer,
      useControlledState = _getInstance.useControlledState; // Setup user reducer ref


  var getStateReducer = useGetLatest(stateReducer); // Build the reducer

  var reducer = React.useCallback(function (state, action) {
    // Detect invalid actions
    if (!action.type) {
      console.info({
        action: action
      });
      throw new Error('Unknown Action 👆');
    } // Reduce the state from all plugin reducers


    return [].concat(_toConsumableArray(getHooks().stateReducers), _toConsumableArray(Array.isArray(getStateReducer()) ? getStateReducer() : [getStateReducer()])).reduce(function (s, handler) {
      return handler(s, action, state, getInstance()) || s;
    }, state);
  }, [getHooks, getStateReducer, getInstance]); // Start the reducer

  var _React$useReducer = React.useReducer(reducer, undefined, function () {
    return reducer(initialState, {
      type: actions.init
    });
  }),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      reducerState = _React$useReducer2[0],
      dispatch = _React$useReducer2[1]; // Allow the user to control the final state with hooks


  var state = reduceHooks([].concat(_toConsumableArray(getHooks().useControlledState), [useControlledState]), reducerState, {
    instance: getInstance()
  });
  Object.assign(getInstance(), {
    state: state,
    dispatch: dispatch
  }); // Decorate All the columns

  var columns = React.useMemo(function () {
    return linkColumnStructure(reduceHooks(getHooks().columns, userColumns, {
      instance: getInstance()
    }));
  }, [getHooks, getInstance, userColumns].concat(_toConsumableArray(reduceHooks(getHooks().columnsDeps, [], {
    instance: getInstance()
  }))));
  getInstance().columns = columns; // Get the flat list of all columns and allow hooks to decorate
  // those columns (and trigger this memoization via deps)

  var allColumns = React.useMemo(function () {
    return reduceHooks(getHooks().allColumns, flattenColumns(columns), {
      instance: getInstance()
    }).map(assignColumnAccessor);
  }, [columns, getHooks, getInstance].concat(_toConsumableArray(reduceHooks(getHooks().allColumnsDeps, [], {
    instance: getInstance()
  }))));
  getInstance().allColumns = allColumns; // Access the row model using initial columns

  var _React$useMemo = React.useMemo(function () {
    var rows = [];
    var flatRows = [];
    var rowsById = {};

    var allColumnsQueue = _toConsumableArray(allColumns);

    while (allColumnsQueue.length) {
      var column = allColumnsQueue.shift();
      accessRowsForColumn({
        data: data,
        rows: rows,
        flatRows: flatRows,
        rowsById: rowsById,
        column: column,
        getRowId: getRowId,
        getSubRows: getSubRows,
        accessValueHooks: getHooks().accessValue,
        getInstance: getInstance
      });
    }

    return [rows, flatRows, rowsById];
  }, [allColumns, data, getRowId, getSubRows, getHooks, getInstance]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 3),
      rows = _React$useMemo2[0],
      flatRows = _React$useMemo2[1],
      rowsById = _React$useMemo2[2];

  Object.assign(getInstance(), {
    rows: rows,
    flatRows: flatRows,
    rowsById: rowsById // materializedColumns,

  });
  loopHooks(getHooks().useInstanceAfterData, getInstance()); // Get the flat list of all columns AFTER the rows
  // have been access, and allow hooks to decorate
  // those columns (and trigger this memoization via deps)

  var visibleColumns = React.useMemo(function () {
    return reduceHooks(getHooks().visibleColumns, allColumns, {
      instance: getInstance()
    }).map(function (d) {
      return decorateColumn(d, defaultColumn);
    });
  }, [getHooks, allColumns, getInstance, defaultColumn].concat(_toConsumableArray(reduceHooks(getHooks().visibleColumnsDeps, [], {
    instance: getInstance()
  })))); // Combine new visible columns with all columns (dedupe prefers later columns)

  allColumns = React.useMemo(function () {
    var columns = _toConsumableArray(allColumns);

    visibleColumns.forEach(function (column) {
      if (!columns.find(function (d) {
        return d.id === column.id;
      })) {
        columns.push(column);
      }
    });
    return columns;
  }, [allColumns, visibleColumns]);
  getInstance().allColumns = allColumns;

  if (process.env.NODE_ENV !== 'production') {
    var duplicateColumns = allColumns.filter(function (column, i) {
      return allColumns.findIndex(function (d) {
        return d.id === column.id;
      }) !== i;
    });

    if (duplicateColumns.length) {
      console.info(allColumns);
      throw new Error("Duplicate columns were found with ids: \"".concat(duplicateColumns.map(function (d) {
        return d.id;
      }).join(', '), "\" in the columns array above"));
    }
  } // Make the headerGroups


  var headerGroups = React.useMemo(function () {
    return reduceHooks(getHooks().headerGroups, makeHeaderGroups(visibleColumns, defaultColumn), getInstance());
  }, [getHooks, visibleColumns, defaultColumn, getInstance].concat(_toConsumableArray(reduceHooks(getHooks().headerGroupsDeps, [], {
    instance: getInstance()
  }))));
  getInstance().headerGroups = headerGroups; // Get the first level of headers

  var headers = React.useMemo(function () {
    return headerGroups.length ? headerGroups[0].headers : [];
  }, [headerGroups]);
  getInstance().headers = headers; // Provide a flat header list for utilities

  getInstance().flatHeaders = headerGroups.reduce(function (all, headerGroup) {
    return [].concat(_toConsumableArray(all), _toConsumableArray(headerGroup.headers));
  }, []);
  loopHooks(getHooks().useInstanceBeforeDimensions, getInstance()); // Filter columns down to visible ones

  var visibleColumnsDep = visibleColumns.filter(function (d) {
    return d.isVisible;
  }).map(function (d) {
    return d.id;
  }).sort().join('_');
  visibleColumns = React.useMemo(function () {
    return visibleColumns.filter(function (d) {
      return d.isVisible;
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [visibleColumns, visibleColumnsDep]);
  getInstance().visibleColumns = visibleColumns; // Header Visibility is needed by this point

  var _calculateHeaderWidth = calculateHeaderWidths(headers),
      _calculateHeaderWidth2 = _slicedToArray(_calculateHeaderWidth, 3),
      totalColumnsMinWidth = _calculateHeaderWidth2[0],
      totalColumnsWidth = _calculateHeaderWidth2[1],
      totalColumnsMaxWidth = _calculateHeaderWidth2[2];

  getInstance().totalColumnsMinWidth = totalColumnsMinWidth;
  getInstance().totalColumnsWidth = totalColumnsWidth;
  getInstance().totalColumnsMaxWidth = totalColumnsMaxWidth;
  loopHooks(getHooks().useInstance, getInstance()) // Each materialized header needs to be assigned a render function and other
  // prop getter properties here.
  ;
  [].concat(_toConsumableArray(getInstance().flatHeaders), _toConsumableArray(getInstance().allColumns)).forEach(function (column) {
    // Give columns/headers rendering power
    column.render = makeRenderer(getInstance(), column); // Give columns/headers a default getHeaderProps

    column.getHeaderProps = makePropGetter(getHooks().getHeaderProps, {
      instance: getInstance(),
      column: column
    }); // Give columns/headers a default getFooterProps

    column.getFooterProps = makePropGetter(getHooks().getFooterProps, {
      instance: getInstance(),
      column: column
    });
  });
  getInstance().headerGroups = React.useMemo(function () {
    return headerGroups.filter(function (headerGroup, i) {
      // Filter out any headers and headerGroups that don't have visible columns
      headerGroup.headers = headerGroup.headers.filter(function (column) {
        var recurse = function recurse(headers) {
          return headers.filter(function (column) {
            if (column.headers) {
              return recurse(column.headers);
            }

            return column.isVisible;
          }).length;
        };

        if (column.headers) {
          return recurse(column.headers);
        }

        return column.isVisible;
      }); // Give headerGroups getRowProps

      if (headerGroup.headers.length) {
        headerGroup.getHeaderGroupProps = makePropGetter(getHooks().getHeaderGroupProps, {
          instance: getInstance(),
          headerGroup: headerGroup,
          index: i
        });
        headerGroup.getFooterGroupProps = makePropGetter(getHooks().getFooterGroupProps, {
          instance: getInstance(),
          headerGroup: headerGroup,
          index: i
        });
        return true;
      }

      return false;
    });
  }, [headerGroups, getInstance, getHooks]);
  getInstance().footerGroups = _toConsumableArray(getInstance().headerGroups).reverse(); // The prepareRow function is absolutely necessary and MUST be called on
  // any rows the user wishes to be displayed.

  getInstance().prepareRow = React.useCallback(function (row) {
    row.getRowProps = makePropGetter(getHooks().getRowProps, {
      instance: getInstance(),
      row: row
    }); // Build the visible cells for each row

    row.allCells = allColumns.map(function (column) {
      var cell = {
        column: column,
        row: row,
        value: row.values[column.id]
      }; // Give each cell a getCellProps base

      cell.getCellProps = makePropGetter(getHooks().getCellProps, {
        instance: getInstance(),
        cell: cell
      }); // Give each cell a renderer function (supports multiple renderers)

      cell.render = makeRenderer(getInstance(), column, {
        row: row,
        cell: cell
      });
      return cell;
    });
    row.cells = visibleColumns.map(function (column) {
      return row.allCells.find(function (cell) {
        return cell.column.id === column.id;
      });
    }); // need to apply any row specific hooks (useExpanded requires this)

    loopHooks(getHooks().prepareRow, row, {
      instance: getInstance()
    });
  }, [getHooks, getInstance, allColumns, visibleColumns]);
  getInstance().getTableProps = makePropGetter(getHooks().getTableProps, {
    instance: getInstance()
  });
  getInstance().getTableBodyProps = makePropGetter(getHooks().getTableBodyProps, {
    instance: getInstance()
  });
  loopHooks(getHooks().useFinalInstance, getInstance());
  return getInstance();
};

function calculateHeaderWidths(headers) {
  var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var sumTotalMinWidth = 0;
  var sumTotalWidth = 0;
  var sumTotalMaxWidth = 0;
  var sumTotalFlexWidth = 0;
  headers.forEach(function (header) {
    var subHeaders = header.headers;
    header.totalLeft = left;

    if (subHeaders && subHeaders.length) {
      var _calculateHeaderWidth3 = calculateHeaderWidths(subHeaders, left),
          _calculateHeaderWidth4 = _slicedToArray(_calculateHeaderWidth3, 4),
          totalMinWidth = _calculateHeaderWidth4[0],
          totalWidth = _calculateHeaderWidth4[1],
          totalMaxWidth = _calculateHeaderWidth4[2],
          totalFlexWidth = _calculateHeaderWidth4[3];

      header.totalMinWidth = totalMinWidth;
      header.totalWidth = totalWidth;
      header.totalMaxWidth = totalMaxWidth;
      header.totalFlexWidth = totalFlexWidth;
    } else {
      header.totalMinWidth = header.minWidth;
      header.totalWidth = Math.min(Math.max(header.minWidth, header.width), header.maxWidth);
      header.totalMaxWidth = header.maxWidth;
      header.totalFlexWidth = header.canResize ? header.totalWidth : 0;
    }

    if (header.isVisible) {
      left += header.totalWidth;
      sumTotalMinWidth += header.totalMinWidth;
      sumTotalWidth += header.totalWidth;
      sumTotalMaxWidth += header.totalMaxWidth;
      sumTotalFlexWidth += header.totalFlexWidth;
    }
  });
  return [sumTotalMinWidth, sumTotalWidth, sumTotalMaxWidth, sumTotalFlexWidth];
}

function accessRowsForColumn(_ref) {
  var data = _ref.data,
      rows = _ref.rows,
      flatRows = _ref.flatRows,
      rowsById = _ref.rowsById,
      column = _ref.column,
      getRowId = _ref.getRowId,
      getSubRows = _ref.getSubRows,
      accessValueHooks = _ref.accessValueHooks,
      getInstance = _ref.getInstance;

  // Access the row's data column-by-column
  // We do it this way so we can incrementally add materialized
  // columns after the first pass and avoid excessive looping
  var accessRow = function accessRow(originalRow, rowIndex) {
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var parent = arguments.length > 3 ? arguments[3] : undefined;
    var parentRows = arguments.length > 4 ? arguments[4] : undefined;
    // Keep the original reference around
    var original = originalRow;
    var id = getRowId(originalRow, rowIndex, parent);
    var row = rowsById[id]; // If the row hasn't been created, let's make it

    if (!row) {
      row = {
        id: id,
        original: original,
        index: rowIndex,
        depth: depth,
        cells: [{}] // This is a dummy cell

      }; // Override common array functions (and the dummy cell's getCellProps function)
      // to show an error if it is accessed without calling prepareRow

      row.cells.map = unpreparedAccessWarning;
      row.cells.filter = unpreparedAccessWarning;
      row.cells.forEach = unpreparedAccessWarning;
      row.cells[0].getCellProps = unpreparedAccessWarning; // Create the cells and values

      row.values = {}; // Push this row into the parentRows array

      parentRows.push(row); // Keep track of every row in a flat array

      flatRows.push(row); // Also keep track of every row by its ID

      rowsById[id] = row; // Get the original subrows

      row.originalSubRows = getSubRows(originalRow, rowIndex); // Then recursively access them

      if (row.originalSubRows) {
        var subRows = [];
        row.originalSubRows.forEach(function (d, i) {
          return accessRow(d, i, depth + 1, row, subRows);
        }); // Keep the new subRows array on the row

        row.subRows = subRows;
      }
    } else if (row.subRows) {
      // If the row exists, then it's already been accessed
      // Keep recursing, but don't worry about passing the
      // accumlator array (those rows already exist)
      row.originalSubRows.forEach(function (d, i) {
        return accessRow(d, i, depth + 1, row);
      });
    } // If the column has an accessor, use it to get a value


    if (column.accessor) {
      row.values[column.id] = column.accessor(originalRow, rowIndex, row);
    } // Allow plugins to manipulate the column value


    row.values[column.id] = reduceHooks(accessValueHooks, row.values[column.id], {
      row: row,
      column: column,
      instance: getInstance()
    }, true);
  };

  data.forEach(function (originalRow, rowIndex) {
    return accessRow(originalRow, rowIndex, 0, undefined, rows);
  });
}